import { Component } from '@angular/core';

@Component({
    selector: 'app-layout',
    templateUrl: './open-layout.component.html'
})

export class OpenLayoutComponent { }
